import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, } from 'react';
import { Icon, Input, IconButton, makeStyles, } from '@material-ui/core';
import { useDebounce, } from 'use-debounce';
import clsx from 'clsx';
const useStyle = makeStyles((theme) => {
    return {
        root: {
            position: 'relative',
            width: '100%',
        },
        searchIcon: {
            width: theme.spacing(4),
            height: '100%',
            position: 'absolute',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        searchInputRoot: {
            color: 'inherit',
            width: '100%',
        },
        searchInput: {
            padding: theme.spacing(1, 3, 1, 4),
            width: '100%',
        },
        clearSearchButton: {
            position: 'absolute',
            right: 0,
            top: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'translateY(-50%)',
        },
    };
}, {
    name: 'SearchBox',
});
export const SearchBox = (props) => {
    var _a;
    const [searchText, setSearchText] = useState((_a = props.initialValue) !== null && _a !== void 0 ? _a : '');
    const [searchTextDebouncedValue] = useDebounce(searchText, props.delay ? props.delay : 1000);
    const searchInputRef = React.useRef();
    const classes = useStyle();
    const { onChange } = props;
    /**
     * This useEffect is used for listening to searchTextDebouncedValue and call the onChange callback
     */
    useEffect(() => {
        onChange(searchTextDebouncedValue);
    }, [onChange, searchTextDebouncedValue]);
    return (_jsxs("div", { className: clsx(props.className, classes.root), style: props.style, children: [_jsx("div", { className: classes.searchIcon, children: _jsx(Icon, { children: "search" }) }), _jsx(Input, { placeholder: props.placeholder || '', classes: {
                    root: classes.searchInputRoot,
                    input: classes.searchInput,
                }, value: searchText, inputProps: {
                    ref: searchInputRef,
                }, onChange: (event) => {
                    if (props.caseSensitive === true) {
                        setSearchText(event.currentTarget.value);
                    }
                    else {
                        setSearchText(event.currentTarget.value.toLowerCase());
                    }
                } }), searchText.length > 0
                && (_jsx(IconButton, { className: classes.clearSearchButton, onClick: () => {
                        searchInputRef.current.value = '';
                        setSearchText('');
                    }, children: _jsx(Icon, { children: "close" }) }))] }));
};
